import services from 'services/module';
import {Observer} from './ViewPortSvc';

export class StopPlaySvc {
    private pauseCount = 1;
    private modalShowOff = angular.noop;
    private modalCloseOff = angular.noop;
    private onScreenOff = angular.noop;
    private notOnScreenOff = angular.noop;
    private windowOnFocusHandler = angular.noop;
    private windowOnBlurHandler = angular.noop;

    constructor(private $rootScope: ng.IRootScopeService,
                private ViewPortSvc: Observer,
                private element: ng.IAugmentedJQuery,
                private handlerPlay: (canPlay: boolean) => void,
                private scrollCentredOn?: number) {
        this.windowControl();
        this.modalControl();
        this.scrollControl(scrollCentredOn);
    }

    deactivate() {
        this.modalShowOff();
        this.modalCloseOff();
        this.onScreenOff();
        this.notOnScreenOff();
        this.ViewPortSvc.unsubscribe(this.element[0]);
        window.removeEventListener('focus', this.windowOnFocusHandler, false);
        window.removeEventListener('blur', this.windowOnBlurHandler, false);
    }

    private windowControl() {
        this.windowOnFocusHandler = this.getPlayHandler(true);
        this.windowOnBlurHandler = this.getPlayHandler(false);

        window.addEventListener('focus', this.windowOnFocusHandler, false);
        window.addEventListener('blur', this.windowOnBlurHandler, false);
    }

    private getPlayHandler(status: boolean) {
        return () => {
            this.pauseCount = status ? Math.max(0, --this.pauseCount) : ++this.pauseCount;
            this.handlerPlay(this.pauseCount === 0);
        }
    }

    private modalControl() {
        this.modalShowOff = this.$rootScope.$on('modal:show', this.getPlayHandler(false));
        this.modalCloseOff = this.$rootScope.$on('modal:close', this.getPlayHandler(true));
    }

    private scrollControl(centredOn?: number) {
        const id = `on-scroll-${Date.now()}`;
        this.element[0].id = id;

        this.onScreenOff = this.$rootScope.$on(`onScreen:${id}`, this.getPlayHandler(true));
        this.notOnScreenOff = this.$rootScope.$on(`notOnScreen:${id}`, this.getPlayHandler(false));

        this.ViewPortSvc.subscribe(this.element[0], centredOn);
        setTimeout(() => this.ViewPortSvc.checker(), 0);
    }
}


export type StopPlaySvcFactory = (element: ng.IAugmentedJQuery,
                                  handlerPlay: (canPlay: boolean) => void,
                                  scrollCentredOn?: number) => StopPlaySvc;

function StopPlaySvcFactory($rootScope: ng.IRootScopeService,
                            ViewPortSvc: Observer) {
    return (element: ng.IAugmentedJQuery,
            handlerPlay: (canPlay: boolean) => void,
            scrollCentredOn?: number) => new StopPlaySvc($rootScope, ViewPortSvc, element, handlerPlay, scrollCentredOn);
}

services.service('stopPlaySvcFactory', StopPlaySvcFactory);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/StopPlaySvc.ts